import apiClient from "../../api/apiClient";

/**
 * SubCategory Service
 * Handles all API calls related to sub category management
 */

// ================= GET ALL SUB CATEGORIES =================
export const getSubCategoriesApi = async (
  page: number,
  pageSize: number,
  tenantId: string,
  search: string
) => {
  const res = await apiClient.get("/subcategories", {
    params: {
      PageNumber: page,
      PageSize: pageSize,
      Search: search,
      tenantId,
    },
  });

  return res.data;
};

// ================= GET SUB CATEGORIES BY CATEGORY =================
export const getSubCategoriesByCategoryApi = async (
  categoryId: string,
  tenantId: string
) => {
  const res = await apiClient.get(
    `/subcategories/by-category/${categoryId}`,
    {
      params: {
        tenantId,
      },
    }
  );

  return res.data;
};

// ================= GET SUB CATEGORY BY ID =================
export const getSubCategoryByIdApi = async (
  id: string,
  tenantId: string
) => {
  const res = await apiClient.get(
    `/subcategories/${id}`,
    {
      params: {
        tenantId,
      },
    }
  );

  return res.data;
};

// ================= CREATE SUB CATEGORY =================
export const createSubCategoryApi = async (
  data: any,
  tenantId: string
) => {
  const res = await apiClient.post(
    "/subcategories",
    data,
    {
      params: {
        tenantId,
      },
    }
  );

  return res.data;
};

// ================= UPDATE SUB CATEGORY =================
export const updateSubCategoryApi = async (
  data: any,
  tenantId: string
) => {
  const res = await apiClient.put(
    `/subcategories/${data.id}`,
    data,
    {
      params: {
        tenantId,
      },
    }
  );

  return res.data;
};

// ================= DELETE SUB CATEGORY =================
export const deleteSubCategoryApi = async (
  id: string,
  tenantId: string
) => {
  const res = await apiClient.delete(
    `/subcategories/${id}`,
    {
      params: {
        tenantId,
      },
    }
  );

  return res.data;
};

export const subCategoryService = {
  getSubCategoriesApi,
  getSubCategoriesByCategoryApi,
  getSubCategoryByIdApi,
  createSubCategoryApi,
  updateSubCategoryApi,
  deleteSubCategoryApi,
};